import {  NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BaseHeaderLayoutComponent } from '../header/header.component';

import { GspSharedModule } from '../../modules';
@NgModule({
    imports: [
        CommonModule,
        GspSharedModule
    ],
    declarations: [
        BaseHeaderLayoutComponent
    ],
    exports: [
        BaseHeaderLayoutComponent
    ],
  
})
export class BaseHeaderLayoutModule { }
